import React, { useEffect, useState, useMemo } from "react";
import PropTypes from "prop-types";
import { Link, useParams, useHistory, withRouter } from "react-router-dom";
import {
  CardBody,
  Container,
  Progress,
  Row,
  Card,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
  Col,
  CardHeader,
  Spinner,
  Alert,
} from "reactstrap";

//Import Breadcrumb
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import CommentaireSlider from "../../../Components/Common/CommentaireSlider";
import TableContainer from "../../../Components/Common/TableContainer";
import Loader from "../../../Components/Common/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withTranslation } from "react-i18next";
import axiosInstance from "../../../axiosConfig";

//redux
import { useDispatch } from "react-redux";
import {
  getCommentChauffeur,
  getNoteChauffeur,
  getRevenuebyChauffeur,
  getCoursesChauffeur,
  getCoursesChauffeurIn,
  getParainageInfoClient,
} from "../../../common/data";
import InfosPersonnelle from "../../../Components/Common/InfosPersonnelle";
import StatistiquesDetail from "../../../Components/Common/StatistiquesDetail";
import NoteCommentaire from "../../../Components/Common/NoteCommentaire";
import DocumentsPersonnelle from "../../../Components/Common/DocumentsPersonnelle";

const DriverActivityHistory = (props) => {
  function formatDate(date) {
    const dateObject = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    });
    return dateObject;
  }

  const AgentId = useParams("id");

  const [reload, setReload] = useState(true);
  const [loading, setLoading] = useState(true);
  const [selectchauffeur, setSelectChauffeur] = useState({});
  const [commentaires, setCommentaires] = useState([]);
  const [notes, setNotes] = useState([]);
  const [chauffeurCourses, setChauffeurCourses] = useState([]);
  const [chauffeurCoursesIn, setChauffeurCoursesIn] = useState([]);
  const [chauffeurCoursesRevenue, setChauffeurCoursesRevenue] = useState(0);
  const [chauffeurParainage, setChauffeurParainage] = useState({
    parainee: 0,
    revenus: 0,
  });

  const dispatch = useDispatch();

  const fetchDriverData = async () => {
    try {
      const driverDetail = await axiosInstance.get(
        `/driverdetail/?id=${AgentId.id}/`
      );

      setSelectChauffeur(driverDetail.data.data);
      // console.log("driverDetail.data.data: ", driverDetail.data.data);

      // console.log("noteCourseChauffeur: ", noteCourseChauffeur);
      if (driverDetail?.data) {
        const driverData = driverDetail.data.data;

        console.log("driverData:: ", driverData);

        const coursesChauffeur = await getCoursesChauffeur(driverData.user_id);
        setChauffeurCourses(coursesChauffeur);

        const coursesChauffeurIn = await getCoursesChauffeurIn(
          driverData.user_id
        );
        setChauffeurCoursesIn(coursesChauffeurIn);

        // console.log("coursesChauffeurIn: ", coursesChauffeurIn);

        const revenuCoursesChauffeur = await getRevenuebyChauffeur(
          driverData.user_id
        );
        setChauffeurCoursesRevenue(revenuCoursesChauffeur);
        // console.log("revenuCoursesChauffeur: ", revenuCoursesChauffeur);

        const commentaireChauffeur = await getCommentChauffeur(
          driverData.user_id
        );
        setCommentaires(commentaireChauffeur);
        // console.log("commentaireChauffeur: ", commentaireChauffeur);

        const noteCourseChauffeur = await getNoteChauffeur(driverData.user_id);
        setNotes(noteCourseChauffeur);

        const parraingeInfo = await getParainageInfoClient(driverData.user_id);
        setChauffeurParainage({
          parainee: parraingeInfo?.filleuls || 0,
          revenus: parraingeInfo?.gains || 0,
        });
      }
      // setChauffeurParainage
    } catch (err) {
      console.error("Echec de récupération des données: ", err);
      toast.error("Échec de récupération des données.");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchDriverData();
    setReload(false);
  }, [reload]);

  const columnsTable = useMemo(
    () => [
      {
        Header: "Nom",
        accessor: "last_name",
        filterable: false,
      },
      {
        Header: "Prénom",
        accessor: "first_name",
        filterable: false,
      },
      {
        Header: "Statut course",
        accessor: "course_status",
        filterable: true,
      },
      {
        Header: "Date Course",
        accessor: "date",
        filterable: false,
        Cell: (cellProps) => {
          return formatDate(cellProps.row.original.date);
        },
      },
      {
        Header: "Rôle",
        accessor: "role",
        filterable: true,
      },
    ],
    []
  );

  const columnsInfo = [
    {
      Header: "Nom",
      accessor: "last_name",
    },
    {
      Header: "Prénoms",
      accessor: "first_name",
    },
    {
      Header: "Note",
      accessor: "note_driver",
    },
    {
      Header: "Téléphone",
      accessor: "telephone",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Type d'engin",
      accessor: "type_engin",
    },
    {
      Header: "Nombre de place",
      accessor: "nbr_place",
    },
    {
      Header: "Marque",
      accessor: "marque",
    },
    {
      Header: "Modele",
      accessor: "modele",
    },
    {
      Header: "Classe de l'engin",
      accessor: "class_engin",
    },
    {
      Header: "Immatriculation",
      accessor: "immatriculation",
    },
    {
      Header: "Climatisation",
      accessor: "climatisation",
    },
  ];

  const columnStatistique = [
    {
      title: "Courses",
      prefix: "",
      suffix: "",
      value: chauffeurCoursesIn.length || 0,
    },
    {
      title: "Revenus",
      prefix: "XOF ",
      suffix: "",
      value: chauffeurCoursesRevenue || 0,
    },
    {
      title: "Filleuls",
      prefix: "",
      suffix: "",
      value: chauffeurParainage.parainee || 0,
    },
    {
      title: "Gains",
      prefix: "XOF ",
      suffix: "",
      value: chauffeurParainage.revenus || 0,
    },
  ];

  const documents = [
    {
      name: "Piece d'identite",
      path: "piece_identite",
      exp: "date_expir_identite",
    },
    {
      name: "Attestation de residence",
      path: "attestation_residence",
      exp: null,
    },
    {
      name: "Permis",
      path: "permis",
      exp: "date_expir_permis",
    },
    {
      name: "Photo",
      path: "photo",
      exp: null,
    },
    {
      name: "Droit taxi",
      path: "droit_taxi",
      exp: null,
    },
    {
      name: "Assurance",
      path: "assurance",
      exp: null,
    },
    {
      name: "Photo engin",
      path: "photo_engin",
      exp: null,
    },
    {
      name: "Carte grise",
      path: "carte_grise",
      exp: null,
    },
    {
      name: "Visite technique",
      path: "visite_technique",
      exp: null,
    },
  ];

  document.title = props.t("Détails du chauffeur | Takci");

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Détails du chauffeur"
            pageTitle="Chauffeurs"
            pageTitleLink="/chauffeur"
          />
          {loading ? (
            <div className="text-center my-5">
              <Spinner color="primary" />
            </div>
          ) : (
            <Row>
              <Col className="col-xxl-3">
                <Card className="h-100 w-100">
                  {selectchauffeur.first_name && selectchauffeur.last_name ? (
                    <>
                      <InfosPersonnelle
                        status={selectchauffeur.statut}
                        avatar={
                          <div className="avatar-title bg-light text-dark rounded">
                            <i
                              className={`ri ri-car-fill`}
                              style={{ fontSize: "50px" }}
                            />
                          </div>
                        }
                        head={
                          selectchauffeur.first_name +
                          " " +
                          selectchauffeur.last_name
                        }
                        since={selectchauffeur.created_at}
                        columns={columnsInfo}
                        data={selectchauffeur}
                      />

                      <DocumentsPersonnelle
                        onReload={() => setReload(!reload)}
                        user_id={selectchauffeur.user_id}
                        accessor={documents}
                        data={selectchauffeur}
                      />
                    </>
                  ) : (
                    <Alert color="warning">
                      Aucune information disponible.
                    </Alert>
                  )}

                  {/* Notes ------ */}
                  {notes.length > 0 ? (
                    <NoteCommentaire data={notes} />
                  ) : (
                    <Alert color="warning">Aucune note disponible</Alert>
                  )}

                  {/* Commentaires ------ */}
                  {commentaires.length > 0 ? (
                    <React.Fragment>
                      <CardBody className="p-4 border-top border-top-dashed">
                        <h6 className="text-muted text-uppercase fw-semibold mb-4">
                          Commentaires
                        </h6>
                        <CommentaireSlider commentaires={commentaires} />
                      </CardBody>
                    </React.Fragment>
                  ) : (
                    <CardBody className="p-4 border-top border-top-dashed">
                      <h6 className="text-muted text-uppercase fw-semibold mb-4">
                        Aucun commentaire disponible
                      </h6>
                    </CardBody>
                  )}
                </Card>
              </Col>

              <Col className="col-xxl-9">
                <Card className="h-100 w-100">
                  <StatistiquesDetail data={columnStatistique} />
                  {chauffeurCoursesIn.length > 0 ? (
                    <Card>
                      <CardBody>
                        <div className="table-card gridjs-border-none pb-2">
                          <TableContainer
                            columns={columnsTable}
                            data={chauffeurCoursesIn || []}
                            isGlobalFilter={false}
                            isAddUserList={false}
                            customPageSize={10}
                            divClass="table-responsive"
                            tableClass="mb-0 table-borderless"
                            theadClass="table-light text-muted"
                          />
                        </div>
                      </CardBody>
                    </Card>
                  ) : (
                    <Alert color="warning">
                      Aucun historique de course disponible.
                    </Alert>
                  )}
                </Card>
              </Col>
            </Row>
          )}

          <ToastContainer closeButton={false} />
        </Container>
      </div>
    </React.Fragment>
  );
};

DriverActivityHistory.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(DriverActivityHistory));
